import { sanitizeSeoText } from "./seoUtils";
import { PLATFORM_FAVICON } from "./documentHead";

export function formatClientViewPageTitle(pageTitle, brandName) {
  const page = sanitizeSeoText(pageTitle);
  const brand = sanitizeSeoText(brandName);
  if (!page) {
    return brand || "";
  }
  if (!brand || page.includes(brand)) {
    return page;
  }
  return `${page} | ${brand}`;
}

export function resolveClientViewBrandName(manifest, slug) {
  return sanitizeSeoText(manifest?.branding?.name) || sanitizeSeoText(slug) || "Client View";
}

export function resolveClientViewDefaultTitle(manifest, slug) {
  return resolveClientViewBrandName(manifest, slug);
}

export function resolveClientViewFavicon(manifest) {
  const favicon = sanitizeSeoText(manifest?.branding?.favicon);
  if (favicon) {
    return favicon;
  }
  const logo = sanitizeSeoText(manifest?.branding?.logo);
  if (logo) {
    return logo;
  }
  return null;
}

export function resolveClientViewAppleTouchIcon(manifest) {
  const logo = sanitizeSeoText(manifest?.branding?.logo);
  if (logo) {
    return logo;
  }
  return resolveClientViewFavicon(manifest) || PLATFORM_FAVICON;
}
